import { render, staticRenderFns } from "./CategoriesPage.vue?vue&type=template&id=fccd1cfa&scoped=true"
import script from "./CategoriesPage.vue?vue&type=script&lang=ts"
export * from "./CategoriesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd1cfa",
  null
  
)

export default component.exports